module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/edit.6438b90e.svg";